<template>
  <footer class="mobile-footer">
    mobile footer area
  </footer>
</template>

<script>


export default {
  name: 'MobileFooter',
  methods: {
  }
}
</script>

<style scoped lang="scss">
.mobile-footer {
  border-top: 1px solid #dbdbdb;
}
</style>
